import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { fetchAuthorized } from './fetchAuthorized';
import { interactiveLogin } from './login';
import { getNewToken } from './getNewToken';
import { interactiveLogout } from './logout';
import { getAccessTokenFromMemory } from './getAccessTokenFromMemory';
import { getLoginUrl as _getLoginUrl } from './getLoginUrl';
import validate from './utils/jwt';

var Auth =
/*#__PURE__*/
function () {
  function Auth(clientConfig, authServerConfig) {
    _classCallCheck(this, Auth);

    this._clientConfig = clientConfig;
    this._authServerConfig = authServerConfig;
  }

  _createClass(Auth, [{
    key: "fetch",
    value: function fetch(input, init) {
      return fetchAuthorized(input, init, this._clientConfig, this._authServerConfig);
    }
  }, {
    key: "login",
    value: function login(redirectUri) {
      return interactiveLogin(this._authServerConfig, this._clientConfig, redirectUri);
    }
  }, {
    key: "logout",
    value: function logout(redirectUri) {
      return interactiveLogout(this._authServerConfig, redirectUri);
    }
  }, {
    key: "getLoginUrl",
    value: function getLoginUrl(redirectUri) {
      return _getLoginUrl(this._authServerConfig, this._clientConfig, redirectUri);
    }
  }, {
    key: "tokenProvider",
    value: function tokenProvider() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var token;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getNewToken(this._clientConfig, this._authServerConfig);

              case 2:
                token = _context.sent;
                return _context.abrupt("return", [token.access_token, token.expires_in]);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var accessTokenFromMemory, _ref, access_token;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                accessTokenFromMemory = getAccessTokenFromMemory();

                if (!accessTokenFromMemory) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", accessTokenFromMemory);

              case 3:
                _context2.next = 5;
                return getNewToken(this._clientConfig, this._authServerConfig);

              case 5:
                _ref = _context2.sent;
                access_token = _ref.access_token;
                return _context2.abrupt("return", access_token);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getIdToken",
    value: function getIdToken() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var token;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this._clientConfig.scopes.indexOf('openid') === -1)) {
                  _context3.next = 2;
                  break;
                }

                throw {
                  error: 'client_error',
                  error_description: 'openid scope is required to get an id_token'
                };

              case 2:
                _context3.next = 4;
                return getNewToken(this._clientConfig, this._authServerConfig);

              case 4:
                token = _context3.sent;

                if (token.id_token) {
                  _context3.next = 7;
                  break;
                }

                throw {
                  error: 'unknown_error',
                  error_description: 'id_token is empty'
                };

              case 7:
                return _context3.abrupt("return", token.id_token);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var idToken, idTokenBody, userInfo;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getIdToken();

              case 2:
                idToken = _context4.sent;
                _context4.next = 5;
                return validate(idToken, this._clientConfig, this._authServerConfig);

              case 5:
                idTokenBody = _context4.sent;
                userInfo = {
                  subject: idTokenBody.sub,
                  email: idTokenBody.email
                };

                if (idTokenBody.preferred_username) {
                  userInfo.profile = {
                    username: idTokenBody.preferred_username,
                    picture: idTokenBody.picture,
                    displayName: idTokenBody.name
                  };
                }

                return _context4.abrupt("return", userInfo);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return Auth;
}();

export var createAuth = function createAuth(clientConfig, authServerConfig) {
  var serverConfig = authServerConfig || {
    url: window.location.hostname.endsWith('spotify.net') ? 'https://accounts.spotify.net' : 'https://accounts.spotify.com'
  };
  return new Auth(clientConfig, serverConfig);
};